module.exports = __webpack_public_path__ + "static/media/caros-light-italic.dfa4059c.woff2";